export default __webpack_public_path__ + "static/media/rectangle_bar.43d4896b.svg";